import React, { useEffect, useState } from "react";
import { IoMdEye } from "react-icons/io";
import { getBecomeAtrainerDetailsapi } from "Services/allApi";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BeAtrainer = () => {
  const [becomeAtrainers, setBecomeAtrainers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    getBecomeATrainerDetails(currentPage);
  }, [currentPage]);



  const getBecomeATrainerDetails = async (page) => {
    try {
      setLoading(true);
      const response = await getBecomeAtrainerDetailsapi(page);
      if (response?.status === 200 && response.data) {
        setBecomeAtrainers(response.data.results);
        setTotalPages(Math.ceil(response.data.count / 10)); // Assume page size is 10
      } else {
        console.error("Unexpected API Response:", response);
        toast.error('Failed to fetch data');

      }
    } catch (error) {
      console.error("Error fetching trainer details:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const openModal = (trainer) => {
    setSelectedTrainer(trainer);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTrainer(null);
  };

  const handlePageChange = (direction) => {
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    } else if (direction === "previous" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <h2 className="mt-5 text-xl font-bold text-center mb-4 dark:text-white">Become a Trainer Details</h2>

      {loading ? (
        <div className="text-center py-4 text-purple-500">Loading...</div>
      ) : (
        <div>
          <div className="overflow-x-auto">
            <table className="table-auto w-full dark:bg-[#0b14374d] dark:text-white">
              <thead>
                <tr className="bg-gray-100 text-left dark:bg-gray-800 dark:text-white">
                  <th className="px-4 py-2 text-left">Full Name</th>
                  <th className="px-4 py-2 text-left">Email</th>
                  <th className="px-4 py-2 text-left">Phone</th>
                  <th className="px-4 py-2 text-left">Date</th>
                  <th className="px-4 py-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {becomeAtrainers.length > 0 ? (
                  becomeAtrainers.map((trainer) => (
                    <tr key={trainer.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                      <td className="px-4 py-2">{trainer.full_name || "N/A"}</td>
                      <td className="px-4 py-2">{trainer.email || "N/A"}</td>
                      <td className="px-4 py-2">{trainer.phone || "N/A"}</td>
                      <td className="px-4 py-2">{trainer.created_at ? new Date(trainer.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }) : "N/A"}</td>
                      <td className="px-4 py-2 text-center">
                        <button
                          className="rounded-lg px-4 py-2 text-green-700 font-large text-large transition duration-200 hover:bg-white-700"
                          onClick={() => openModal(trainer)}
                        >
                          <IoMdEye className='text-green-700 text-2xl' />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-4 py-2 text-center text-red-500"
                    >
                      No trainers found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center items-center mt-4 space-x-4">
            <button
              className="rounded-lg bg-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-400"
              disabled={currentPage === 1}
              onClick={() => handlePageChange("previous")}
            >
              Previous
            </button>
            <span className="text-gray-700">Page {currentPage} of {totalPages}</span>
            <button
              className="rounded-lg bg-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-400"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange("next")}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {isModalOpen && selectedTrainer && (
        <div onClick={closeModal} className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg shadow-lg w-full max-w-lg dark:!bg-navy-700 dark:text-white max-h-[90vh] flex flex-col">
            <div className="p-6 border-b dark:border-gray-600">
              <h2 className="text-xl font-bold text-center dark:text-white">Trainer Details</h2>
            </div>
            <div className="p-6 space-y-4 overflow-y-auto flex-1">
              <div>
                <p className="text-gray-700 font-medium dark:text-white">Professional Experience:</p>
                <p className="text-gray-900 dark:text-white">{selectedTrainer.experience || "N/A"}</p>
              </div>
              <div>
                <p className="text-gray-700 font-medium dark:text-white">Additional Information:</p>
                <p className="text-gray-900 dark:text-white">{selectedTrainer.motivation || "N/A"}</p>
              </div>
            </div>
            <div className="p-6 border-t dark:border-gray-600 text-center">
              <button
                className="rounded-lg bg-red-600 px-4 py-2 text-white font-medium text-sm transition duration-200 hover:bg-red-500"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />

    </>
  );
};

export default BeAtrainer;